@if (editInline()) {
    <se-numeric-cell-editor-inline
        [numericFormControl]="formControl"
        [min]="min()"
        [max]="max()"
        [decimal]="decimal()"
        [separatorInUse]="separatorInUse()"
        [cellReady]="cellReady()"
    >
    </se-numeric-cell-editor-inline>
} @else {
    <se-numeric-cell-editor-popup
        [numericFormControl]="formControl"
        [min]="min()"
        [max]="max()"
        [decimal]="decimal()"
        [separatorInUse]="separatorInUse()"
        [width]="cellWidth()"
        [cellReady]="cellReady()"
    >
    </se-numeric-cell-editor-popup>
}
